import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../../../api";

export const signupApi = createApi({
  reducerPath: "signupApi", // Unique key in Redux store
  baseQuery: fetchBaseQuery({ baseUrl: baseURL }),
  endpoints: (builder) => ({
    signupHandler: builder.query({
      query: ({ 
        endpoint, payload,
        beforeCallback,
        afterCallback,
        successCallback,
        failureCallback
      }) => ({
        method: "POST",
        url: endpoint,
        body: payload
      })
    })
  }),
});

export const { 
  useSignupHandlerMutation
} = signupApi;

// Export the lazy query functions (for manual triggering)
export const {
  useLazySignupHandlerQuery
} = signupApi;
